import { action } from 'easy-peasy';

const uploadModel = {
  isUploading: false,
  progress: 0,
  fileName: '',
  source: null,

  startUpload: action((state, payload) => {
    state.isUploading = true;
    state.progress = 0;
    state.fileName = payload?.fileName ?? '';
    state.source = payload?.source ?? null;
  }),

  setProgress: action((state, payload) => {
    state.progress = payload;
  }),

  finishUpload: action((state) => {
    state.isUploading = false;
    state.progress = 0;
    state.fileName = '';
    state.source = null;
  })
};

export default uploadModel;
